/* eslint-disable react/react-in-jsx-scope */
// import React from "react";
// import ReactDOM from "react-dom";
// import { ThemeProvider, StylesProvider, jssPreset } from "@material-ui/styles";
// import { CssBaseline } from "@material-ui/core";
// import { create } from "jss";
// import "animate.css";
// import Themes from "./themes";
// import App from "./components/App";
// import * as serviceWorker from "./serviceWorker";
// import { LayoutProvider } from "./context/LayoutContext";
// import { UserProvider } from "./context/UserContext";
// import { ToastContainer } from "react-toastify";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import "react-toastify/dist/ReactToastify.css";
// import "leaflet/dist/leaflet.css";

// import "./globalStyles.css";

// const jss = create({ plugins: [...jssPreset().plugins] });

// ReactDOM.render(
//   <LayoutProvider>
//     <UserProvider>
//       <ToastContainer />
//       <ThemeProvider theme={Themes.default}>
//         <StylesProvider jss={jss}>
//           <CssBaseline />
//           <App />
//         </StylesProvider>
//       </ThemeProvider>
//     </UserProvider>
//   </LayoutProvider>,
//   document.getElementById("root"),
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

import React from "react";
import ReactDOM from "react-dom";
import {
  Button,
  CssBaseline,
  Slide,
  Snackbar as MaterialSnackbar,
} from "@material-ui/core";
import {
  jssPreset,
  StylesProvider,
  ThemeProvider,
} from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
// import { LocalizationProvider, AdapterDateFns } from "@material-ui/lab";
import * as Sentry from "@sentry/browser";
import "animate.css";
import { create } from "jss";
import { StrictMode, useCallback, useEffect, useState } from "react";
import ReactGA from "react-ga";
// import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import { SWRConfig } from "swr";
import shallow from "zustand/shallow";
import App from "./components/App";
import SnackBar from "./components/SnackBar";
import { ToastContainer } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import "./globalStyles.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import themes from "./themes";
import { useGlobalState } from "./utils";
import { usePwa } from "@dotmind/react-use-pwa";
import { usePWAInstall } from "react-use-pwa-install";

const jss = create({ plugins: [...jssPreset().plugins] });

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  ignoreErrors: ["ResizeObserver loop limit exceeded"],
  enabled: process.env.NODE_ENV === "production",
});
ReactGA.initialize(process.env.REACT_APP_GA, {
  testMode: process.env.NODE_ENV !== "production",
});
const swrConfig = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  // , fetcher: api.get
};

const Start = () => {
  // const { pathname } = useLocation();
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const install = usePWAInstall();
  // const [install, setInstall] = useState(false);
  // const {
  //   installPrompt,
  //   isInstalled,
  //   isStandalone,
  //   isOffline,
  //   canInstall,
  // } = usePwa();

  // const handleInstallPrompt = useCallback(() => {
  //   if (canInstall) {
  //     setInstall(false);
  //     installPrompt();
  //   }
  // }, [canInstall, installPrompt]);

  const { stuff, setStuff } = useGlobalState(
    useCallback(
      (e) => ({
        stuff: e.stuff,
        setStuff: e.setStuff,
      }),
      [],
    ),
    shallow,
  );

  const updateSW = useCallback(() => {
    // eslint-disable-next-line no-unused-expressions
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });
    setNewVersionAvailable(false);
    window.location.reload();
  }, [waitingWorker]);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: ({ waiting }) => {
        setWaitingWorker(waiting);
        setNewVersionAvailable(true);
      },
    });
  }, []);

  console.log(stuff);

  useEffect(() => {
    setStuff("Learn React");
  }, [setStuff]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log(isStandalone);
  //     console.log(isInstalled);
  //     if (!isInstalled || !isStandalone) {
  //       setInstall(true);
  //     }
  //   }, 2000);
  // }, [isInstalled, isStandalone]);

  // useEffect(() => {
  //   ReactGA.set({ page: pathname, anonymizeIp: true });
  //   ReactGA.pageview(pathname);
  // }, [pathname]);

  return (
    <ThemeProvider theme={themes.default}>
      <LayoutProvider>
        <UserProvider>
          <ToastContainer />
          <SWRConfig value={swrConfig}>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
            <StylesProvider jss={jss}>
              <CssBaseline />
              {/* <ReactPWAInstallProvider enableLogging> */}
              <App />
              {/* </ReactPWAInstallProvider> */}
            </StylesProvider>
            <SnackBar />
            <MaterialSnackbar
              open={newVersionAvailable}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              TransitionComponent={Slide}
              TransitionProps={{ direction: "up" }}
            >
              <Alert
                variant="filled"
                severity="info"
                sx={{ alignItems: "center", ".MuiAlert-action": { p: 0 } }}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={updateSW}
                    style={{ color: "red" }}
                    sx={{ p: 1 }}
                  >
                    {"Update!"}
                  </Button>
                }
                style={{ color: "#000" }}
              >
                {"New Version"}
              </Alert>
            </MaterialSnackbar>
            <MaterialSnackbar
              open={install}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              TransitionComponent={Slide}
              TransitionProps={{ direction: "up" }}
            >
              <Alert
                variant="filled"
                severity="info"
                sx={{ alignItems: "center", ".MuiAlert-action": { p: 0 } }}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={install}
                    style={{ color: "red" }}
                    sx={{ p: 1 }}
                  >
                    {"install"}
                  </Button>
                }
                style={{ color: "#000" }}
              >
                {"Install App"}
              </Alert>
            </MaterialSnackbar>
            {/* </LocalizationProvider> */}
          </SWRConfig>
        </UserProvider>
      </LayoutProvider>
    </ThemeProvider>
  );
};

ReactDOM.render(
  <StrictMode>
    <Start />
  </StrictMode>,
  document.querySelector("#root"),
);

serviceWorkerRegistration.register();
reportWebVitals(({ id, name, value }) => {
  ReactGA.event({
    category: "Web Vitals",
    action: name,
    value: Math.round(name === "CLS" ? value * 1000 : value),
    label: id,
    nonInteraction: true,
  });
});
